import { render, staticRenderFns } from "./TagProfileDialog.vue?vue&type=template&id=50f57ef0&"
import script from "./TagProfileDialog.vue?vue&type=script&lang=js&"
export * from "./TagProfileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports